<template>
  <div class="ricerca col-24 no-padding">
    <ricerca-panel :filtri="filtriRicerca"
                   @closeRicerca="closeRicerca"
                   @changeValueOrClick="changeValueOrClick"
                   @cerca="cerca"></ricerca-panel>
  </div>
</template>

<script>
  import RicercaPanel from '@/components/ServiceComponents/RicercaPanel'
  import {bus} from '../../../Bus.js'

  export default {
    name: 'Ricerca',
    components: {RicercaPanel},
    i18n: {
      messages: {
        it_IT: {
          ricerca: {
            filtri: 'Filtri',
            statoNazione: 'Stato',
            codForn: 'Codice Fornitore',
            fornitore: 'Fornitore / Sub-fornitore',
            dipendente: 'Dipendente',
            sesso: 'Sesso',
            comuneNascita: 'Comune di Nascita',
            cittadinanza: 'Cittadinanza',
            residenza: 'Residenza',
            tipoRapp: 'Tipo Rapporto',
            mansione: 'Mansione',
            dataAssunzione: 'Data Assunzione',
            cerca: 'Cerca',
            scegli: 'Scegli...'
          }
        },
        fr_FR: {
          ricerca: {
            filtri: 'Filtres',
            statoNazione: 'Pays',
            codForn: 'Code du Fournisseur',
            fornitore: 'fournisseur / Sous-traitant',
            dipendente: 'Employé',
            sesso: 'Sexe',
            comuneNascita: 'Lieu de naissance',
            cittadinanza: 'Citoyenneté',
            residenza: 'Résidence',
            tipoRapp: 'Type de rapport',
            mansione: 'Tâche',
            dataAssunzione: 'Embauché le',
            cerca: 'Recherche',
            scegli: 'Choisir...'
          }
        },
        es_ES: {
          ricerca: {
            filtri: 'Filtros',
            statoNazione: 'País',
            codForn: 'Código de Proveedor',
            fornitore: 'Proveedor / Subcontratista',
            dipendente: 'Empleado',
            sesso: 'Sexo',
            comuneNascita: 'Lieu de naissance',
            cittadinanza: 'Ciudadanía',
            residenza: 'Residencia',
            tipoRapp: 'Tipo de relacion',
            mansione: 'Tarea',
            dataAssunzione: 'Contratado el',
            cerca: 'Búsqueda',
            scegli: 'Elegir...'
          }
        },
        de_DE: {
          ricerca: {
            filtri: 'Filter',
            statoNazione: 'Land',
            codForn: 'Lieferantencode',
            fornitore: 'Lieferant / Subunternehmer',
            dipendente: 'Mitarbeiter',
            sesso: 'Sex',
            comuneNascita: 'Geburtsort',
            cittadinanza: 'Staatsbürgerschaft',
            residenza: 'Residenz',
            tipoRapp: 'Arbeitsbeziehungstyp',
            mansione: 'Aufgabe',
            dataAssunzione: 'Angestellt am',
            cerca: 'Suche',
            scegli: 'Wählen...'
          }
        },
        en_GB: {
          ricerca: {
            filtri: 'Filters',
            statoNazione: 'Country',
            codForn: 'Supplier Code',
            fornitore: 'Supplier / Subcontractor',
            dipendente: 'Employee',
            sesso: 'Sex',
            comuneNascita: 'Birthplace',
            cittadinanza: 'Citizenship',
            residenza: 'Residence',
            tipoRapp: 'Relationship type',
            mansione: 'Task',
            dataAssunzione: 'Hired on',
            cerca: 'Search',
            scegli: 'Choose...'
          }
        }
      }
    },
    props: {
      prefixApp: {
        type: String
      }
    },
    data () {
      return {
        codLang: sessionStorage.getItem('codLang'),
        codForn: '',
        codFornAdmin: {},
        firstLoad: true,
        filtriRicerca: {
          loading: false,
          titolo: '',
          valueSelected: {
            0: '',
            1: {},
            2: '',
            3: '',
            4: '',
            5: '',
            6: '',
            7: '',
            8: '',
            9: ''
          },
          dati: {
            0: [],
            1: [],
            2: [],
            4: [],
            6: [],
            7: [],
            8: [],
            9: []
          },
          filtri: [
            // Select con le country a cui è abilitato l'utente
            {
              type: 'select',
              myLabel: '',
              value: 'country',
              label: 'desc',
              key: 'country',
              onChangeOrClick: 'changeCountry',
              ifClearable: false,
              ifDisabled: false
            },
            // Select con i fornitori
            {
              type: 'select-with-object',
              myLabel: '',
              value: '',
              label: ['codForn', 'desForn'],
              key: 'codForn',
              onChangeOrClick: 'changeCodForn',
              ifClearable: false,
              ifDisabled: false,
              ifShow: false
            },
            // Select Fotrnitori / Sub-fornitori
            {
              type: 'select',
              myLabel: '',
              value: 'codForn',
              label: 'desForn',
              key: 'codForn',
              ifClearable: false,
              ifDisabled: false
            },
            // Dipendente
            {
              type: 'input',
              myLabel: '',
              ifClearable: true
            },
            // Sesso
            {
              type: 'select',
              myLabel: '',
              value: 'codSesso',
              label: 'desSesso',
              key: 'codSesso',
              ifClearable: true,
              ifDisabled: false
            },
            // Comune di Nascita
            {
              type: 'input',
              myLabel: '',
              ifClearable: true
            },
            // Cittadinanza
            {
              type: 'select',
              myLabel: '',
              value: 'codCittadinanza',
              label: 'desCittadinanza',
              key: 'codCittadinanza',
              ifClearable: true,
              ifDisabled: false,
              ifFilterable: true
            },
            // Residenza
            {
              type: 'select',
              myLabel: '',
              value: 'codCittadinanza',
              label: 'desCittadinanza',
              key: 'codCittadinanza',
              ifClearable: true,
              ifDisabled: false,
              ifFilterable: true
            },
            // Tipo Rapporto
            {
              type: 'select',
              myLabel: '',
              value: 'codTipoRapp',
              label: 'desTipoRapp',
              key: 'codTipoRapp',
              ifClearable: true,
              ifDisabled: false
            },
            // Mansione
            {
              type: 'select',
              myLabel: '',
              value: 'codMansione',
              label: 'desMansione',
              key: 'codMansione',
              ifClearable: true,
              ifDisabled: false
            } /*,
            // Date picker con range di ricerca per DATA SPEDIZIONE
            {
              type: 'dt-picker',
              myLabel: '',
              ifClearable: true,
              format: 'dd/MM/yyyy',
              valueFormat: 'yyyyMMdd',
              typePicker: 'daterange',
              onChangeOrClick: 'changeRangeDataSped'
            } */
          ]
        }
      }
    },
    mounted: function () {
      bus.$on('changeLanguage', () => {
        this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
        this.$nextTick(() => {
          this.getCountries(true)
          this.setTraduzioniLabel()
        })
      })
      bus.$on('Header_SetCodFornAdmin', () => {
        if (localStorage.hasOwnProperty('amministrazione')) {
          this.$set(this, 'codFornAdmin', JSON.parse(localStorage.getItem('amministrazione')))
          this.$set(this, 'codForn', this.codFornAdmin.ACCSTA[this.filtriRicerca.valueSelected[0]])
        } else {
          this.$set(this, 'codFornAdmin', {})
          this.$set(this, 'codForn', '')
        }
        if (!this._inactive) {
          this.$set(this.filtriRicerca.dati, 1, [])
          this.$set(this.filtriRicerca.dati, 2, [])
          this.$set(this.filtriRicerca.dati, 4, [])
          this.$set(this.filtriRicerca.dati, 6, [])
          this.$set(this.filtriRicerca.dati, 7, [])
          this.$set(this.filtriRicerca.dati, 8, [])
          this.$set(this.filtriRicerca.dati, 9, [])
          this.$set(this.filtriRicerca.valueSelected, 1, {})
          this.$set(this.filtriRicerca.valueSelected, 2, '')
          this.$set(this.filtriRicerca.valueSelected, 3, '')
          this.$set(this.filtriRicerca.valueSelected, 4, '')
          this.$set(this.filtriRicerca.valueSelected, 5, '')
          this.$set(this.filtriRicerca.valueSelected, 6, '')
          this.$set(this.filtriRicerca.valueSelected, 7, '')
          this.$set(this.filtriRicerca.valueSelected, 8, '')
          this.$set(this.filtriRicerca.valueSelected, 9, '')

          if (this.codForn) {
            // this.getSocieta()
          }
        }
      })
    },
    activated: function () {
      this.init()
    },
    methods: {
      init: function () {
        this.$nextTick(() => {
          this.$store.dispatch('ifObject', 'DIP_Ricerca').then((ifRicerca) => {
            if (ifRicerca) {
              let form = this.$store.state.DIP_Ricerca
              this.$set(this.filtriRicerca.valueSelected, 0, form.country)
              this.$set(this, 'codForn', form.codForn)
              let fornObj = {
                codForn: form.codForn,
                desForn: ''
              }
              this.$set(this.filtriRicerca.valueSelected, 1, fornObj)
              this.$set(this.filtriRicerca.valueSelected, 2, form.fornitore)
              this.$set(this.filtriRicerca.valueSelected, 3, form.dipendente)
              this.$set(this.filtriRicerca.valueSelected, 4, form.sesso)
              this.$set(this.filtriRicerca.valueSelected, 5, form.comuneNascita)
              this.$set(this.filtriRicerca.valueSelected, 6, form.cittadinanza)
              this.$set(this.filtriRicerca.valueSelected, 7, form.nazioneRes)
              this.$set(this.filtriRicerca.valueSelected, 8, form.tipoRapporto)
              this.$set(this.filtriRicerca.valueSelected, 9, form.mansione)
            } else {
              this.$set(this.filtriRicerca.valueSelected, 0, '')
              this.$set(this.filtriRicerca.valueSelected, 1, {})
              this.$set(this.filtriRicerca.valueSelected, 2, '')
              this.$set(this.filtriRicerca.valueSelected, 3, '')
              this.$set(this.filtriRicerca.valueSelected, 4, '')
              this.$set(this.filtriRicerca.valueSelected, 5, '')
              this.$set(this.filtriRicerca.valueSelected, 6, '')
              this.$set(this.filtriRicerca.valueSelected, 7, '')
              this.$set(this.filtriRicerca.valueSelected, 8, '')
              this.$set(this.filtriRicerca.valueSelected, 9, '')
            }

            // Se esiste nel localStorage l'oggetto amministrazione lo setto
            if (localStorage.hasOwnProperty('amministrazione')) {
              this.$set(this, 'codFornAdmin', JSON.parse(localStorage.getItem('amministrazione')))
            }

            // Chiamo il servizio per la lista degli Stati a cui sono abilitato passando come parametro false (NON sto cambiando lingua)
            this.getCountries(false)

            // Chiamo il metodo per settare le traduzioni delle label nella lingua impostata
            this.setTraduzioniLabel()
          })
        })
      },
      setTraduzioniLabel: function () {
        this.$set(this.filtriRicerca, 'titolo', this.$t('ricerca.filtri'))
        this.$set(this.filtriRicerca.filtri[0], 'myLabel', this.$t('ricerca.statoNazione'))
        this.$set(this.filtriRicerca.filtri[1], 'myLabel', this.$t('ricerca.codForn'))
        this.$set(this.filtriRicerca.filtri[2], 'myLabel', this.$t('ricerca.fornitore'))
        this.$set(this.filtriRicerca.filtri[3], 'myLabel', this.$t('ricerca.dipendente'))
        this.$set(this.filtriRicerca.filtri[4], 'myLabel', this.$t('ricerca.sesso'))
        this.$set(this.filtriRicerca.filtri[5], 'myLabel', this.$t('ricerca.comuneNascita'))
        this.$set(this.filtriRicerca.filtri[6], 'myLabel', this.$t('ricerca.cittadinanza'))
        this.$set(this.filtriRicerca.filtri[7], 'myLabel', this.$t('ricerca.residenza'))
        this.$set(this.filtriRicerca.filtri[8], 'myLabel', this.$t('ricerca.tipoRapp'))
        this.$set(this.filtriRicerca.filtri[9], 'myLabel', this.$t('ricerca.mansione'))
        // this.$set(this.filtriRicerca.filtri[10], 'myLabel', this.$t('ricerca.dataAssunzione'))
      },
      closeRicerca: function () {
        this.$emit('closeRicerca')
      },
      cerca: function () {
        let form = {
          country: this.filtriRicerca.valueSelected[0],
          codForn: this.codForn,
          fornitore: this.filtriRicerca.valueSelected[2] ? this.filtriRicerca.valueSelected[2] : '',
          dipendente: this.filtriRicerca.valueSelected[3] ? this.filtriRicerca.valueSelected[3].toUpperCase() : '',
          sesso: this.filtriRicerca.valueSelected[4] ? this.filtriRicerca.valueSelected[4] : '',
          comuneNas: this.filtriRicerca.valueSelected[5] ? this.filtriRicerca.valueSelected[5] : '',
          cittadinanza: this.filtriRicerca.valueSelected[6] ? this.filtriRicerca.valueSelected[6] : '',
          nazioneRes: this.filtriRicerca.valueSelected[7] ? this.filtriRicerca.valueSelected[7] : '',
          tipoRapporto: this.filtriRicerca.valueSelected[8] ? this.filtriRicerca.valueSelected[8] : '',
          mansione: this.filtriRicerca.valueSelected[9] ? this.filtriRicerca.valueSelected[9] : ''
          // dataAssunzione: this.filtriRicerca.valueSelected[10]
        }
        // this.$store.commit('set', {key: 'DIP_Ricerca', value: form})
        // sessionStorage.setItem('AnagDip_form', JSON.stringify(form))
        this.$emit('cerca', JSON.stringify(form))
      },
      changeValueOrClick: function (index) {
        if (this.filtriRicerca.filtri[index].hasOwnProperty('onChangeOrClick')) {
          this[this.filtriRicerca.filtri[index].onChangeOrClick]()
        }
      },
      getCountries: function (ifChangeLang) {
        this.$http.get('portale/countries', {
          params: {
            codLang: this.codLang,
            codiApp: 'WebAnagraficaDip'
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              let data = response.body.data
              this.$set(this.filtriRicerca.dati, 0, data)
              if (data.length > 0) {
                this.$store.dispatch('ifObject', 'DIP_Ricerca').then((ifRicerca) => {
                  // Se NON c'è una ricerca già salvata in VUEX
                  if (!ifRicerca) {
                    // Verifico se lo Stato impostato nel localStorage esiste tra quelli restituiti dal servizio delle abilitazioni
                    let flag = data.some(e => e.country === localStorage.getItem('ACCSTA_country'))
                    // Se flag = true uso lo Stato del localStorage
                    this.$set(this.filtriRicerca.valueSelected, 0, flag ? localStorage.getItem('ACCSTA_country') : data[0].country)
                  }
  
                  // Se NON sto cambiando lingua procedo, altrimenti tolgo il loader
                  if (!ifChangeLang) {
                    this.getFornitoreInfo(false)
                  } else {
                    // this.$set(this.filtriRicerca, 'loading', false)
                  }
                })
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              // this.$set(this.filtriRicerca, 'loading', false)
            }
          })
      },
      /*  Al momento del cambio della country vengono azzerati array e valori in richiamare i servizi
       */
      changeCountry: function () {
        this.$set(this.filtriRicerca.dati, 1, [])
        this.$set(this.filtriRicerca.dati, 2, [])
        this.$set(this.filtriRicerca.dati, 4, [])
        this.$set(this.filtriRicerca.dati, 6, [])
        this.$set(this.filtriRicerca.dati, 7, [])
        this.$set(this.filtriRicerca.dati, 8, [])
        this.$set(this.filtriRicerca.dati, 9, [])
        this.$set(this.filtriRicerca.valueSelected, 1, {})
        this.$set(this.filtriRicerca.valueSelected, 2, '')
        this.$set(this.filtriRicerca.valueSelected, 3, '')
        this.$set(this.filtriRicerca.valueSelected, 4, '')
        this.$set(this.filtriRicerca.valueSelected, 5, '')
        this.$set(this.filtriRicerca.valueSelected, 6, '')
        this.$set(this.filtriRicerca.valueSelected, 7, '')
        this.$set(this.filtriRicerca.valueSelected, 8, '')
        this.$set(this.filtriRicerca.valueSelected, 9, '')

        this.$store.commit('set', {key: 'DIP_Ricerca', value: {}})
        this.$store.commit('set', {key: 'DIP_Dipendente', value: {}})
        this.$store.commit('set', {key: 'DIP_new', value: false})
        this.$store.commit('set', {key: 'DIP_Documento', value: {}})
        this.$store.commit('set', {key: 'DOC_Ricerca', value: {}})
        this.$store.commit('set', {key: 'GA_Documento', value: {}})
        this.$store.commit('set', {key: 'ASD_Ricerca', value: {}})
        sessionStorage.removeItem('ACCSTA_fornitore')

        if (localStorage.hasOwnProperty('amministrazione')) {
          this.$set(this, 'codForn', this.codFornAdmin.ACCSTA[this.filtriRicerca.valueSelected[0]])
        }
        this.getFornitoreInfo(true)
      },
      getFornitoreInfo: function (ifChangeCountry) {
        // this.$set(this.filtriRicerca, 'loading', true)
        this.$http.get('anagraficadipendenti/info', {
          params: {
            codLang: this.codLang,
            country: this.filtriRicerca.valueSelected[0]
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              // Se utente è FORNITORE o AGENTE
              if (response.body.attrib.typeOfUser === 'fornitore') {
                let data = response.body.data
                this.$set(this.filtriRicerca.dati, 1, data)
                this.$set(this.filtriRicerca.filtri[1], 'ifDisabled', (data.length <= 1))
                this.$set(this.filtriRicerca.filtri[1], 'ifShow', true)

                this.$store.dispatch('ifObject', 'DIP_Ricerca').then((ifRicerca) => {
                  // Se NON c'è una ricerca salvata in VUEX oppure sto cambiando Stato
                  if (!ifRicerca || ifChangeCountry) {
                    // Se esiste un codForn ACCSTA salvato
                    if (sessionStorage.hasOwnProperty('ACCSTA_fornitore')) {
                      let ACCSTA_fornitore = sessionStorage.getItem('ACCSTA_fornitore')
                      let flag = false
                      data.forEach((forn) => {
                        if (forn.codForn === ACCSTA_fornitore) {
                          flag = true
                          this.$set(this.filtriRicerca.valueSelected, 1, forn)
                          this.$set(this, 'codForn', forn.codForn)
                        }
                      })
                      if (!flag) {
                        this.$set(this.filtriRicerca.valueSelected, 1, data[0])
                        this.$set(this, 'codForn', data[0].codForn)
                      }
                    }
                    // Se NON esiste un codForn ACCSTA salvato
                    else {
                      this.$set(this.filtriRicerca.valueSelected, 1, data[0])
                      this.$set(this, 'codForn', data[0].codForn)
                    }
                  }
  
                  if (this.codForn) {
                    this.getSubfornitori(ifChangeCountry)
                    this.getTipoRapp()
                    this.getCittadinanza()
                    this.getMansioni()
                    this.getSesso()
                  } else {
                    this.$emit('loadingOff')
                    // this.$set(this.filtriRicerca, 'loading', false)
                  }
                })
              }
              // Utente AMMINISTRATORE
              else if (response.body.attrib.typeOfUser === 'admin') {
                // Se esiste l'oggetto amministrazione e il codForn ACCSTA per lo Stato selezionato è valorizzato allora lo uso
                if (localStorage.hasOwnProperty('amministrazione') && this.codFornAdmin.ACCSTA[this.filtriRicerca.valueSelected[0]]) {
                  this.$set(this, 'codForn', this.codFornAdmin.ACCSTA[this.filtriRicerca.valueSelected[0]])
                }
  
                this.$set(this.filtriRicerca.filtri[1], 'ifShow', false)
                if (this.codForn) {
                  this.getSubfornitori(ifChangeCountry)
                  this.getTipoRapp()
                  this.getCittadinanza()
                  this.getMansioni()
                  this.getSesso()
                } else {
                  this.$emit('loadingOff')
                  // this.$set(this.filtriRicerca, 'loading', false)
                }
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      getSubfornitori: function (ifChangeCountry) {
        this.$http.get('anagraficadipendenti/subfornitori', {
          params: {
            codLang: this.codLang,
            country: this.filtriRicerca.valueSelected[0],
            codForn: this.codForn
          }
        })
          .then(response => {
            let data = response.body.data
            if (response.body.rc === 0 && data.length > 0) {
              this.$set(this.filtriRicerca.dati, 2, data)
              this.$store.dispatch('ifObject', 'DIP_Ricerca').then((ifRicerca) => {
                // Se non è salvata una ricerca in VUEX la lancio
                if (!ifRicerca) {
                  this.$set(this.filtriRicerca.valueSelected, 2, data[0].codForn)
                  // Se NON sto cambiando stato effettuo la ricerca
                  if (!ifChangeCountry) {
                    this.cerca()
                  }
                }
              })
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              // this.$set(this.filtriRicerca, 'loading', false)
            }
          })
      },
      getTipoRapp: function () {
        this.$http.get('anagraficadipendenti/tiporapp', {
          params: {
            codLang: this.codLang,
            country: this.filtriRicerca.valueSelected[0]
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this.filtriRicerca.dati, 8, response.body.data)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              // this.$set(this.filtriRicerca, 'loading', false)
            }
          })
      },
      getCittadinanza: function () {
        this.$http.get('anagraficadipendenti/cittadinanza', {
          params: {
            codLang: this.codLang,
            country: this.filtriRicerca.valueSelected[0],
             filtro: ''
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this.filtriRicerca.dati, 6, response.body.data)
              this.$set(this.filtriRicerca.dati, 7, response.body.data)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              // this.$set(this.filtriRicerca, 'loading', false)
            }
          })
      },
      getMansioni: function (ifChangeLang) {
        this.$http.get('anagraficadipendenti/mansioni', {
          params: {
            codLang: this.codLang,
            country: this.filtriRicerca.valueSelected[0],
             filtro: ''
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this.filtriRicerca.dati, 9, response.body.data)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              // this.$set(this.filtriRicerca, 'loading', false)
            }
          })
      },
      getSesso: function () {
        this.$http.get('anagraficadipendenti/sesso', {
          params: {
            codLang: this.codLang,
            country: this.filtriRicerca.valueSelected[0]
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this.filtriRicerca.dati, 4, response.body.data)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              // this.$set(this.filtriRicerca, 'loading', false)
            }
          })
      },
      changeCodForn: function () {
        this.$set(this, 'codForn', this.filtriRicerca.valueSelected[1].codForn)

        this.$set(this.filtriRicerca.dati, 2, [])
        this.$set(this.filtriRicerca.valueSelected, 2, '')
  
        this.getSubfornitori()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../../assets/less/general.less";

  .ricerca {
    height: 100%;
    position: absolute;
    z-index: 10;
    .header-tab {
      height: 65px;
      border-bottom: 1px solid #007c74;
      text-align: center;
      .icon-search {
        line-height: 65px;
        .el-button {
          height: 40px;
          width: 40px;
          border-radius: 0px;
          margin-top: 12px;
          margin-left: 10px;
          padding: 0px;
          color: @greenRiva;
          float: left;
          border: 1px solid @greenRiva;
        }
        .el-button:hover {
          background-color: @white;
        }
      }
    }
    .el-table::before {
      height: 0px;
    }
    .el-table {
      border-bottom: none;
      height: 430px;
      overflow: auto;
      .el-table__fixed-right {
        box-shadow: none;
        -webkit-box-shadow: none;
        .el-table__fixed-body-wrapper {
          top: 41px;
        }
      }
      .el-table__fixed-right::before {
        height: 0px;
      }
      .el-table__header {
        border-bottom: 1px solid @greenRiva;
        thead {
          th {
            padding: 5px 0px 0px 0px;
            &:not(.is-sortable) {
              .cell {
                margin-top: -7px;
              }
            }
            .cell {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding-left: 10px !important;
              .set-font(@color: @greenRiva; @weight: bold; @size: 12px);
            }
          }
        }
      }
      .el-table__body {
        tbody {
          tr {
            &.expanded {
              background-color: #e7e7e7;
              td {
                background-color: #e7e7e7 !important;
              }
            }
            &.hover-row {
              td {
                background-color: @white;
              }
            }
            &.single {
              .el-table__expand-icon {
                display: none;
              }
            }
            td {
              padding-top: 5px;
              padding-bottom: 5px;
              .cell {
                .set-font(@size: 12px; @color: #606266);
                .pointer:hover {
                  cursor: pointer;
                }
                .fa-icon {
                  margin-top: 4px;
                }
              }
              -webkit-transition: none;
              transition: none;
            }
            .el-table__expanded-cell {
              padding: 0px !important;
              .el-table__header-wrapper {
                display: none;
              }
              .el-table {
                height: auto !important;
                .el-table__body {
                  tr {
                    td {
                      border-bottom: 0px;
                      &.cella-evidenziata {
                        background-color: #e7e7e7;
                      }
                    }
                  }
                }
              }
              .el-table::before {
                height: 0px;
              }
              .el-table__empty-block {
                display: none;
              }
            }
          }
        }
      }
    }
  }
  .riv-denied-c0 {
    fill: #818181;
  }
  .riv-details-c0 {
    fill: #818181;
  }
  .riv-fornitori-c0 {
    fill: @oroRiva;
  }
  .riv-docFornitore-c0 {
    fill: @oroRiva;
  }
</style>



// WEBPACK FOOTER //
// src/components/AccessoStabilimenti/GestioneAppalti/AnagraficaDipendenti/Ricerca.vue